export const ResolutionMap = {
    '549x800': {
        label: '549 × 800',
        width: 549,
        height: 800,
        scale: 1,
        settingValue: [549, 800] as [number, number],
    },
    '561x818': {
        label: '561 × 818',
        width: 561,
        height: 818,
        scale: 1,
        settingValue: [561, 818] as [number, number],
    },
    '813x1185': {
        label: '813 × 1185',
        width: 813,
        height: 1185,
        scale: 1,
        settingValue: [813, 1185] as [number, number],
    },
    '1122x1636': {
        label: <div style={{ color: 'var(--main-warning)' }}>1122 × 1636</div>,
        width: 1122,
        height: 1636,
        scale: 2,
        settingValue: [1122, 1636] as [number, number],
    },
    '1388x2026': {
        label: <div style={{ color: 'var(--main-warning)' }}>1388 × 2026</div>,
        width: 1388,
        height: 2026,
        scale: 2,
        settingValue: [1388, 2026] as [number, number],
    },
    '1626x2370': {
        label: <div style={{ color: 'var(--main-warning)' }}>1626 × 2370</div>,
        width: 1626,
        height: 2370,
        scale: 2,
        settingValue: [1626, 2370] as [number, number],
    },
};
export const ResolutionList = [
    ResolutionMap['549x800'],
    ResolutionMap['561x818'],
    ResolutionMap['813x1185'],
    ResolutionMap['1122x1636'],
    ResolutionMap['1388x2026'],
    ResolutionMap['1626x2370'],
];